import { FormSectionHandler } from '../entity.handler';
import { IdName, CompanySSLCertificate } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
import { ListFieldValue } from 'app/shared/components/form-builder/list/list.component';
import { ICONS } from '../icons';

interface EditorValues {
    domains: ListFieldValue<IdName>[];
}

interface LimitedCompanyResponse {
    id?: string;
    sslCertificates?: CompanySSLCertificate[];
}

export class SharedSslCertificatesSectionHandler<T extends LimitedCompanyResponse> implements FormSectionHandler<T, EditorValues> {

    type = 'form';
    icon = ICONS.sslcertificate;
    bulk = false;
    readonly = true;
    hidden = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    modified = false;

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.CLIENT.SSLCERTIFICATES.${key}`, values);
    }

    async applyUpdate(entity: T, _payload: any): Promise<T> {
        // we don't support saving
        return entity;
    }

    async mapEntityToEditor(entity: T): Promise<EditorValues> {
        // only show this editor section if there are SSL certificates configured for this company, otherwise people may get confused while we import the existing data
        this.hidden = !entity.sslCertificates || entity.sslCertificates.length === 0;
        return {
            domains: (entity.sslCertificates || []).map(item => this.itemToListItem(item.id, item)),
        };
    }

    async mapEditorToEntity(_entity: T, _values: EditorValues): Promise<any> {
        return {}; // we don't support saving
    }

    async getFields(entity: T): Promise<FormBuilderField[]> {

        const fields: FormBuilderField[] = [
            {
                id: 'domains', title: this.translate('FIELDS.DOMAINS'), type: 'list', required: false, actions: [],
                getText: (field: FormBuilderField, values: any) => {
                    return values[field.id] && values[field.id].map(x => {
                        const domain = x.name.split('.').filter(x=>x).join('.');
                        if (this.admin.user.owner.type === 'system') {
                            return `<a href="#/admin/system/00000000-0000-0000-0000-000000000000/sslcertificates/grid/sslcertificate/${x.id}">${domain}</a> (${x.description})`;
                        }
                        return `<a href="https://${domain}" target="_blank">${domain}</a> (${x.description})`;
                    }).join('<br/>');
                },
            },
        ];
        return EntityUtils.prepareBulk(!entity, [], fields);
    }


    itemToListItem(id: string, item: CompanySSLCertificate): ListFieldValue<IdName> {
        return {
            id: id,
            name: item.domain,
            description: item.state,
            icon: 'password',
            data: item,
        };
    }

    updateOrAddItem(items: ListFieldValue<IdName>[], id: string, item: CompanySSLCertificate) {

        const idx = items.findIndex(x => x.id === id);
        if (idx > -1) {
            items[idx] = this.itemToListItem(id, item);
        } else {
            items.push(this.itemToListItem(id, item));
        }

    }



}

